import { Form } from "@circle-react-uikit/Form";
import { EmojiPickerWrapper } from "@circle-react-uikit/Form/FormEmojiPickerV3Wrapper";
import { useModalData } from "@circle-react-uikit/ModalV2";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { useFocusOnLoad } from "@circle-react/hooks/useFocusOnLoad";

import { t } from "@/i18n-js/instance";
import { SpaceGroupSelect } from "@/react/components/SettingsApp/CompassCompat/SpaceGroupSelect";

const BasicInfo = () => {
  const inputRef = useFocusOnLoad();
  const spaceGroupsContext = useSpaceGroupsContext();
  const spaceGroups = spaceGroupsContext.records;
  const { contentPortalElement } = useModalData();
  const { isCircleV4 } = useCircleV4();

  return (
    <>
      <Form.Item
        name="name"
        hideDescription
        translationRoot="spaces.form.create.basic_info"
        rules={{
          required: t("spaces.form.create.basic_info.name_required"),
          maxLength: 255,
        }}
        hideBorder
        fullWidth
        isFirstChild
        variant="extra-bottom-margin"
      >
        <Form.Input
          ref={inputRef}
          prefix={<EmojiPickerWrapper enableIcons={isCircleV4} />}
        />
      </Form.Item>
      <Form.Item
        name="space_group_id"
        translationRoot="spaces.form.create.basic_info"
        hideDescription
        rules={{
          required: t("spaces.form.create.basic_info.space_group_id_required"),
          maxLength: 255,
        }}
        hideBorder
        fullWidth
        variant="extra-bottom-margin"
      >
        <SpaceGroupSelect
          variant="form-input"
          spaceGroups={spaceGroups}
          name="space_group_id"
          appendTo={contentPortalElement}
        />
      </Form.Item>
    </>
  );
};

export default BasicInfo;
